import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/7e5541a56ec34f9c335c4f691557a0ff/511904ad93867d769e16f6d50376127a.png";

const navLinks = [
  { label: "アイルランド留学", href: "/#charms" },
  { label: "語学学校", href: "/#schools" },
  { label: "高校留学", href: "/#highschool" },
  { label: "よくある質問", href: "/#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("/#")) {
      e.preventDefault();
      const id = href.replace("/#", "");
      if (isHome) {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = href;
      }
      setMenuOpen(false);
    } else {
      setMenuOpen(false);
    }
  };

  const transparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        transparent ? "bg-transparent" : "bg-white shadow-sm"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-32 h-10 flex items-center justify-center">
            <img src={LOGO_URL} alt="ClassLive留学アイルランド" className="h-full w-auto object-contain" />
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) =>
            link.href.startsWith("/#") ? (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleAnchorClick(e, link.href)}
                className={`text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                  transparent ? "text-white hover:text-emerald-200" : "text-gray-700 hover:text-emerald-600"
                }`}
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                className={`text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                  transparent ? "text-white hover:text-emerald-200" : "text-gray-700 hover:text-emerald-600"
                }`}
              >
                {link.label}
              </Link>
            )
          )}
          <Link
            to="/counseling"
            className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            無料相談する
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="メニュー"
        >
          <span className={`block w-5 h-0.5 transition-all ${transparent ? "bg-white" : "bg-gray-700"}`} />
          <span className={`block w-5 h-0.5 transition-all ${transparent ? "bg-white" : "bg-gray-700"}`} />
          <span className={`block w-5 h-0.5 transition-all ${transparent ? "bg-white" : "bg-gray-700"}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-4">
          {navLinks.map((link) =>
            link.href.startsWith("/#") ? (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleAnchorClick(e, link.href)}
                className="text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                onClick={() => setMenuOpen(false)}
                className="text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer"
              >
                {link.label}
              </Link>
            )
          )}
          <Link
            to="/counseling"
            onClick={() => setMenuOpen(false)}
            className="bg-emerald-600 text-white text-sm font-semibold px-4 py-2 rounded-full text-center cursor-pointer"
          >
            無料相談する
          </Link>
        </div>
      )}
    </header>
  );
}
